import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import NavLinks from '../../NavLinks';

import validate from './TeamEntrySelectOrgUnitValidation';

import useOmeMeetData from '../../../../state/omeMeet/UseOmeMeetData';
import useOmeMeetEntryInfoDropdown from '../../../../components/dropdowns/UseOmeMeetEntryInfoDropdown';
import useOmeMeetOrgUnitEntryData from '../../../../state/omeMeetOrgUnitEntry/UseOmeMeetOrgUnitEntryData';
import useOmeMeetOrgUnitEntryInfoData from '../../../../state/omeMeetOrgUnitEntryInfo/UseOmeMeetOrgUnitEntryInfoData';
import useOmeMeetTeamEntryData from '../../../../state/omeMeetTeamEntry/UseOmeMeetTeamEntryData';

import useSearchMeetData from '@usas/ui-web/state/searchMeet/UseSearchMeetData';
import usePersonOrgRoleData from '@usas/ui-web/state/personOrgRole/UsePersonOrgRoleData';

import UseForm from '@usas/ui-web/utils/UseForm';
import Constants from '@usas/ui-web/utils/Constants';

const useTeamEntryOrgUnitSelection = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { omeMeetState, clearOmeMeetArrayData, setOmeMeetState } = useOmeMeetData();
    const { omeMeetEntryInfoState } = useOmeMeetEntryInfoDropdown();
    const { omeMeetOrgUnitEntryState, postOmeMeetOrgUnitEntry, clearOmeMeetOrgUnitEntryObjData,
        clearOmeMeetOrgUnitEntryArrayData } = useOmeMeetOrgUnitEntryData();
    const { omeMeetOrgUnitEntryInfoState, getOmeMeetOrgUnitEntryInfo } = useOmeMeetOrgUnitEntryInfoData();
    const { resetOmeMeetTeamEntryState } = useOmeMeetTeamEntryData();
    const { personOrgRoleState, clearArrayData } = usePersonOrgRoleData();
    const { searchMeetState, setSearchMeetState } = useSearchMeetData();
    const [state, setState] = useState({ radioButtonList: [], showRadioButtonList: false, tryGetOmeMeetOrgUnitEntryInfo: false, tryRedirect: false });
    const { handleSubmit, formState, errorState, onValueTextPairChanged, onFormValueChanged, setFormState
    } = UseForm(getInitialFormState, submitFormCallback, validate);

    const onBackClicked = (e) => {
        if (e?.preventDefault) {
            e.preventDefault();
        }
        clearOmeMeetOrgUnitEntryObjData();
        clearOmeMeetOrgUnitEntryArrayData();
        clearOmeMeetArrayData();
        resetOmeMeetTeamEntryState();
        clearArrayData();

        navigate(NavLinks.MEET_ENTRY_TEAM);
    };

    function submitFormCallback() {
        handlePost();
    }

    function handlePost() {
        postOmeMeetOrgUnitEntry(omeMeetState.objData.omeMeetId, formState.omeMeetEntryId, createOmeMeetOrgUnitEntryObject());
        setOmeMeetState({ ...omeMeetState, route: 'meet' });
        setState({ ...state, tryGetOmeMeetOrgUnitEntryInfo: true });
    }

    function createOmeMeetOrgUnitEntryObject() {
        const todaysDateTime = new Date();
        return {
            omeMeetId: omeMeetState.objData.omeMeetId,
            omeMeetEntryId: formState.omeMeetEntryId,
            orgUnitId: formState.orgUnitId ? formState.orgUnitId : state.radioButtonList[0]?.value,
            orgUnitEntryDatetime: todaysDateTime,
            orgUnitSubmissionDatetime: null,
            orgUnitRegistrationStartDate: null,
            orgUnitRegistrationEndDate: null,
            status: formState.orgUnitId ? (state.radioButtonList && state.radioButtonList?.find(x => x.orgUnitId === formState.orgUnitId)?.label === 'Unattached' ? Constants.WORKFLOW_STATUS_UNATTACHED : Constants.WORKFLOW_STATUS_IN_PROGRESS) :
                (state.radioButtonList[0]?.label === 'Unattached' ? Constants.WORKFLOW_STATUS_UNATTACHED : Constants.WORKFLOW_STATUS_IN_PROGRESS),
            orgUnitAthleteRegistrationAllowed: formState.orgUnitId ? (state.radioButtonList && state.radioButtonList?.find(x => x.orgUnitId === formState.orgUnitId)?.label === 'Unattached' ? true : null) :
                (state.radioButtonList[0]?.label === 'Unattached' ? true : null),
        }
    }

    useEffect(() => {
        if (location.state.availableOrgUnits?.length > 0) {
            setState({ ...state, showRadioButtonList: location.state.availableOrgUnits.length > 1 ? true : false })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (omeMeetEntryInfoState.isArrayLoaded === true && omeMeetEntryInfoState.omeMeetId === omeMeetState.objData.omeMeetId)
            if (omeMeetEntryInfoState.options?.length === 2) {
                //Only one OME Entry & One Org Unit - auto add
                if (location.state.availableOrgUnits?.length === 1) {
                    setFormState({
                        ...formState,
                        omeMeetEntryId: omeMeetEntryInfoState.options[1]?.id,
                        omeMeetEntryName: omeMeetEntryInfoState.options[1]?.name,
                        orgUnitId: location.state.availableOrgUnits[0]?.value
                    });
                }
                else {
                    //Otherwise show options
                    const selectedOmeMeetEntry = omeMeetState.arrayData?.find(x => x.omeMeetEntryId === omeMeetEntryInfoState.options[1]?.id);
                    if (selectedOmeMeetEntry) {
                        setState({ ...state, radioButtonList: selectedOmeMeetEntry?.orgUnit?.map(x => { return ({ label: x.orgUnitName, value: x.orgUnitId }) }), showRadioButtonList: true });
                    }
                    else {
                        setState({ ...state, radioButtonList: [], showRadioButtonList: true })
                    }

                    setFormState({
                        ...formState,
                        omeMeetEntryId: omeMeetEntryInfoState.options[1]?.id,
                        omeMeetEntryName: omeMeetEntryInfoState.options[1]?.name
                    });
                }
            }
            else {
                //Otherwise show options
                const selectedOmeMeetEntry = omeMeetState.arrayData?.find(x => x.omeMeetEntryId === formState.omeMeetEntryId);
                if (selectedOmeMeetEntry) {
                    setState({ ...state, radioButtonList: selectedOmeMeetEntry?.orgUnit?.map(x => { return ({ label: x.orgUnitName, value: x.orgUnitId }) }), showRadioButtonList: true });
                }
                else {
                    setState({ ...state, radioButtonList: [], showRadioButtonList: true })
                }
            }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [omeMeetEntryInfoState, omeMeetState.objData.omeMeetId, formState.omeMeetEntryId])

    useEffect(() => {
        if (personOrgRoleState.isArrayLoading === false && personOrgRoleState.isArrayLoaded === true &&
            state.showRadioButtonList === false && formState.omeMeetEntryId !== Constants.DEFAULT_ID &&
            formState.orgUnitId !== '' && omeMeetState.isArrayLoaded === true && omeMeetState.arrayData.length > 0) {
            handlePost();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [personOrgRoleState.isArrayLoading, personOrgRoleState.isArrayLoaded, state.showRadioButtonList, formState.omeMeetEntryId, formState.orgUnitId, omeMeetState.arrayData, omeMeetState.isArrayLoaded])

    useEffect(() => {
        if (state.tryGetOmeMeetOrgUnitEntryInfo === true && omeMeetOrgUnitEntryState.isSaving === false &&
            omeMeetOrgUnitEntryState.isSaved === true && omeMeetState.route === 'meet') {
            getOmeMeetOrgUnitEntryInfo(omeMeetOrgUnitEntryState.objData?.omeMeetOrgUnitEntryId);
            setState({ ...state, tryGetOmeMeetOrgUnitEntryInfo: false, tryRedirect: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [omeMeetOrgUnitEntryState, state.tryGetOmeMeetOrgUnitEntryInfo, omeMeetState.route])

    useEffect(() => {
        if (state.tryRedirect === true && omeMeetOrgUnitEntryState.isSaving === false &&
            omeMeetOrgUnitEntryState.isSaved === true && omeMeetOrgUnitEntryInfoState.isObjLoaded === true &&
            omeMeetOrgUnitEntryInfoState.objData?.omeMeetOrgUnitEntryId === omeMeetOrgUnitEntryState.objData?.omeMeetOrgUnitEntryId
            && omeMeetState.route === 'meet') {
            setSearchMeetState({ ...searchMeetState, showMeetHeader: false });
            navigate(NavLinks.OU_ADMIN_MEET_INFO, { state: { isReadOnly: false } });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [omeMeetOrgUnitEntryState, omeMeetOrgUnitEntryInfoState, state.tryRedirect, omeMeetState.route])

    function getInitialFormState() {
        return {
            omeMeetEntryId: Constants.DEFAULT_ID,
            omeMeetEntryName: '--',
            orgUnitId: ''
        };
    }

    return {
        state,
        handleSubmit,
        formState,
        errorState,
        onValueTextPairChanged,
        onFormValueChanged,
        personOrgRoleState,
        omeMeetState,
        omeMeetEntryInfoState,
        omeMeetOrgUnitEntryState,
        omeMeetOrgUnitEntryInfoState,
        onBackClicked
    };
};

export default useTeamEntryOrgUnitSelection;